import * as Sentry from "@sentry/react"
import { MantineProvider } from '@mantine/core'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import { AuthKitProvider } from '@workos-inc/authkit-react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router'
import App from './App.tsx'
import { store } from './app/store'
import './index.css'
import { theme } from './theme'

Sentry.init({
  release: import.meta.env.VITE_SENTRY_RELEASE,
  // Vite mode: 'staging' (Cloudflare Worker), 'production' (Azure) or 'development'.
  environment: import.meta.env.MODE,
  dsn: "https://e05f7b6473077c47c6a75f0c30552bd4@o4507801910116352.ingest.us.sentry.io/4510479639183360",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById('root')!, {
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <Sentry.ErrorBoundary fallback={({ eventId }) => (
    <main role="alert" style={{ padding: 24, maxWidth: 480, margin: '48px auto', fontFamily: 'sans-serif' }}>
      <h1>ParcelQuest could not open this screen</h1>
      <p>Please reload the app. If this continues, contact ParcelQuest support.</p>
      {eventId && <p>Support reference: {eventId}</p>}
      <button type="button" onClick={() => window.location.reload()}>Reload app</button>
    </main>
  )}>
  <MantineProvider forceColorScheme="light" theme={theme}>
    {/* redirectUri must match the /callback route: AuthKit only exchanges the
        auth code when the current pathname equals the redirectUri's pathname. */}
    {/* apiHostname: the custom Authentication API domain. Without it, sessions can't be restored after a
        reload outside localhost, because AuthKit can't read WorkOS's session cookie. */}
    <AuthKitProvider
      clientId={import.meta.env.VITE_WORKOS_CLIENT_ID}
      redirectUri={import.meta.env.VITE_WORKOS_REDIRECT_URI}
      apiHostname={import.meta.env.VITE_WORKOS_API_HOSTNAME || undefined}
    >
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </AuthKitProvider>
  </MantineProvider>
  </Sentry.ErrorBoundary>
)
